import  { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 577, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 576 })
  return isMobile ? children : null
}

const UniversalDesktop = ({children}) => {
  const isUniversalTable = useMediaQuery({ minWidth: 577 })
  return isUniversalTable ? children : null
}

const UniversalTable = ({children}) => {
  const isUniversalTable = useMediaQuery({ maxWidth: 991 })
  return isUniversalTable ? children : null
}

export default {Desktop, Tablet, Mobile, UniversalTable, UniversalDesktop}
